const coeficiente = [
    {dias:1, valor:1}, 
    {dias:2, valor:1.5}, 
    {dias:3, valor:2}, 
    {dias:4, valor:2.5}, 
    {dias:5, valor:2.75}, 
    {dias:6, valor:3}, 
    {dias:7, valor:3.3}, 
    {dias:8, valor:3.6}, 
    {dias:9, valor:4}, 
    {dias:10, valor:4.3}, 
    {dias:11, valor:4.6}, 
    {dias:12, valor:5}, 
    {dias:13, valor:5.3}, 
    {dias:14, valor:5.6}, 
    {dias:15, valor:6}, 
    {dias:16, valor:6.3}, 
    {dias:17, valor:6.6}, 
    {dias:18, valor:7}, 
    {dias:19, valor:7.3}, 
    {dias:20, valor:7.6}, 
    {dias:21, valor:8}, 
    {dias:22, valor:8.3}, 
    {dias:23, valor:8.6}, 
    {dias:24, valor:9}, 
    {dias:25, valor:9.3}, 
    {dias:26, valor:9.6}, 
    {dias:27, valor:10}, 
    {dias:28, valor:10.3}, 
    {dias:29, valor:10.6}, 
    {dias:30, valor:11}, 
    {dias:31, valor:11.3},
    {dias:32, valor:11.6},
    {dias:33, valor:12},
    {dias:34, valor:12.3},
    {dias:35, valor:12.6},
    {dias:36, valor:13},
    {dias:37, valor:13.3},
    {dias:38, valor:13.6},
    {dias:39, valor:14},
    {dias:40, valor:14.3},
    {dias:41, valor:14.6},
    {dias:42, valor:15},
]

module.exports = {
    coeficiente
}